import { USER_STATUS_CHANGE } from "actions/types";
import { UserStatus } from "constants/UserConstants";
import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  status: UserStatus.NOT_READY,
  statusTime: null,
};

const userReducer = createReducer(initialState, {
  [USER_STATUS_CHANGE]: (state, action) => {
    state.status = action.payload.updatedStatus;
    state.statusTime = action.payload.updatedStatusTime;
  },
});

export default userReducer;
